var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 12 44 40",
    stroke: "#b6bbcc",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 31.2 L30.7 14.4 C31.45 13.7 32.55 13.7 33.3 14.4 L51 31.2 C52 32.15 51.35 33.8 49.95 33.8 H46.4 V46.8 C46.4 49.1 44.55 51 42.25 51 H36.45 V41.15 C36.45 39.2 34.85 37.6 32.9 37.6 H31.1 C29.15 37.6 27.55 39.2 27.55 41.15 V51 H21.75 C19.45 51 17.6 49.1 17.6 46.8 V33.8 H14.05 C12.65 33.8 12 32.15 13 31.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.454841,20.099871 V 19.825193 16.940274 C 39.454841,15.940274 40.2,16.1 41.2,16.1 h 3.2 c 1,0 1.80638,0.80002 1.8,1.8 l -0.05484,8.59503"
  }))));
};
export default SvgHome;